<template>
  <CanvasButton
    class="margin-right"
    :clicked="canvas.showFeatures"
    text="Feature Bounding Boxes"
    added-class="accent-border-hover"
    :has-options="false"
    @button-clicked="updateShowFeatures(!canvas.showFeatures)"
  />
</template>

<script>
import { LineSegments, EdgesGeometry, BufferGeometry, BufferAttribute } from 'three';
import { meshMeta } from '@/assets/js/3d_viewer/SparkModules/MeshCreation';
import CanvasButton from './CanvasButton.vue';
import { mapState, mapMutations } from 'vuex';

const nameOfMeshObject = 'feature_bounding_box';

export default {
  name: 'FeatureBoundingBoxViewer',

  components: {
    CanvasButton,
  },

  props: {
    viewScaleFactor: {
      type: Number,
      default: 1,
    },
  },

  emits: ['add-mesh-to-scene', 'delete-mesh-from-scene'],

  computed: {
    ...mapState(['part']),
    ...mapState('canvas', ['canvas']),

    showFeatures() {
      return this.canvas.showFeatures;
    },

    boundingBoxesData() {
      return {
        vertices: this.part.feature_bb_vertices,
      };
    },
  },

  watch: {
    showFeatures: {
      handler(newVal) {
        if (newVal) {
          const bbs = this.createBoundingBoxes();
          this.$emit('add-mesh-to-scene', bbs);
        } else {
          this.$emit('delete-mesh-from-scene', nameOfMeshObject);
        }
      },
    },
  },

  methods: {
    ...mapMutations('canvas', ['updateShowFeatures']),

    createBoundingBoxes() {
      const numberFeatures = this.boundingBoxesData.vertices?.length || 0;
      const bbs = [];
      for (let cntFeature = 0; cntFeature < numberFeatures; cntFeature++) {
        const vertBBfromBackend = this.boundingBoxesData.vertices[cntFeature];
        const vertScaled = new Float32Array(vertBBfromBackend.flat().map(coord => coord * this.viewScaleFactor));

        const bufferGeometry = new BufferGeometry();
        bufferGeometry.setAttribute('position', new BufferAttribute(vertScaled, 3));
        const edgesGeometry = new EdgesGeometry(bufferGeometry);

        const bb = new LineSegments(edgesGeometry, meshMeta.featureBoundingBox.material);
        bb.name = nameOfMeshObject;
        bb.renderOrder = meshMeta.featureBoundingBox.renderOrder;
        bbs.push(bb);
      }
      return bbs;
    },
  },
};
</script>
